import { Link } from 'react-router';
import { Bell, Cloud, Download, KeyRound, MessageCircle, Sparkles } from 'lucide-react';
import { useI18n } from '../i18n';

const WITH_ACCOUNT = [
  [Cloud, 'account.sync'],
  [Bell, 'account.push'],
  [MessageCircle, 'account.whatsapp'],
  [Sparkles, 'account.ai'],
] as const;

/** Qué funciona sin cuenta y qué aporta una. Se muestra en la bienvenida y en Ajustes → Cuenta. */
export function AccountBenefits() {
  const { t } = useI18n();
  return (
    <div className="stack" data-testid="account-benefits">
      <p className="small">{t('account.local')}</p>
      <p className="small" style={{ fontWeight: 700, margin: 0 }}>
        {t('account.withTitle')}
      </p>
      <ul className="stack" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {WITH_ACCOUNT.map(([Icon, key]) => (
          <li key={key} className="row small" style={{ alignItems: 'flex-start' }}>
            <Icon size={18} aria-hidden="true" style={{ flex: 'none', color: 'var(--primary)' }} />
            <span>{t(key)}</span>
          </li>
        ))}
      </ul>
      <p className="row muted small" style={{ alignItems: 'flex-start' }}>
        <KeyRound size={16} aria-hidden="true" style={{ flex: 'none' }} />
        <span>{t('account.access')}</span>
      </p>
      <p className="row muted small" style={{ alignItems: 'flex-start' }}>
        <Download size={16} aria-hidden="true" style={{ flex: 'none' }} />
        <span>{t('account.export')}</span>
      </p>
    </div>
  );
}

/** Mensaje único para las funciones que necesitan cuenta (notificaciones, resumen, WhatsApp, Premium). */
export function NeedsAccount({ feature }: { feature: 'push' | 'whatsapp' | 'premium' }) {
  const { t } = useI18n();
  return (
    <p className="small" data-testid="needs-account">
      {t(`account.needs.${feature}`)} {t('account.needs.rest')} <Link to="/settings/account">{t('account.cta')}</Link>
    </p>
  );
}
